import { render, staticRenderFns } from "./mc-meal-card.tests.vue?vue&type=template&id=2c58c4e0&scoped=true"
import script from "./mc-meal-card.tests.vue?vue&type=script&lang=ts"
export * from "./mc-meal-card.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58c4e0",
  null
  
)

export default component.exports